import { ApiError, api } from '../api.js';
import { clear, el } from '../ui.js';

/** Login screen. Rendered whenever there is no valid session. */

export const renderLogin = (root: HTMLElement, onSuccess: () => void): void => {
  clear(root);

  const error = el('p', { class: 'login__error', role: 'alert', hidden: 'hidden' });
  const input = el('input', {
    type: 'password',
    id: 'password',
    class: 'input',
    autocomplete: 'current-password',
    // iOS keyboards otherwise capitalise and autocorrect the password.
    autocapitalize: 'none',
    autocorrect: 'off',
    spellcheck: 'false',
    required: 'required',
    'aria-label': 'Password',
    placeholder: 'Password',
  });
  const submit = el('button', { type: 'submit', class: 'button button--primary' }, ['Log in']);

  const showError = (message: string): void => {
    error.textContent = message;
    error.removeAttribute('hidden');
  };

  const form = el('form', { class: 'login__form', novalidate: 'novalidate' }, [
    el('label', { class: 'sr-only', for: 'password' }, ['Password']),
    input,
    submit,
    error,
  ]);

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (submit.disabled) return;

    error.setAttribute('hidden', 'hidden');
    submit.disabled = true;
    submit.textContent = 'Checking…';

    void (async () => {
      try {
        await api.login(input.value);
        onSuccess();
      } catch (err) {
        showError(err instanceof ApiError ? err.message : 'Invalid password.');
        input.value = '';
        input.focus();
      } finally {
        submit.disabled = false;
        submit.textContent = 'Log in';
      }
    })();
  });

  root.append(
    el('div', { class: 'login' }, [
      el('div', { class: 'login__card' }, [
        el('h1', { class: 'login__title' }, ['Daycare Cam']),
        el('p', { class: 'login__subtitle' }, ['Enter the password to watch the live camera.']),
        form,
      ]),
    ]),
  );

  input.focus();
};
